var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBoPrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 27.5132,
    width: 27,
    height: 27,
    rx: 2.5,
    transform: "rotate(-180 27.5 27.5132)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3155 9.01447C16.4742 9.01415 16.6281 9.07212 16.7504 9.17833C16.8192 9.23814 16.876 9.31159 16.9177 9.39449C16.9594 9.47738 16.9851 9.56807 16.9933 9.66139C17.0015 9.7547 16.9921 9.84879 16.9656 9.93828C16.939 10.0278 16.8959 10.1109 16.8387 10.1829L12.7989 13.998L16.848 17.8311C16.9044 17.904 16.9466 17.9878 16.972 18.0778C16.9975 18.1678 17.0057 18.2622 16.9962 18.3556C16.9867 18.4489 16.9598 18.5394 16.9168 18.6218C16.8739 18.7042 16.8159 18.7768 16.7461 18.8356C16.6758 18.9005 16.5934 18.9494 16.5042 18.9793C16.415 19.0092 16.3209 19.0195 16.2277 19.0095C16.1346 18.9994 16.0444 18.9693 15.9629 18.921C15.8814 18.8727 15.8102 18.8073 15.754 18.7288L11.1546 14.4504C11.0546 14.3229 11 14.163 11 13.998C11 13.833 11.0546 13.6731 11.1546 13.5456L15.7515 9.27095C15.8196 9.18473 15.9062 9.11658 16.0042 9.07202C16.1022 9.02745 16.2088 9.00774 16.3155 9.01447Z",
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 27.5132,
    width: 27,
    height: 27,
    rx: 2.5,
    transform: "rotate(-180 27.5 27.5132)",
    stroke: "#CCCCCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoPrev);
export default __webpack_public_path__ + "static/media/icon__bo__prev.2267ca91e9a107dd0b48076184517af6.svg";
export { ForwardRef as ReactComponent };